import { $sxhr } from "../../stempcore";
import { logout } from "../common/sbase";
import { Subject } from "rxjs";

function httpPost(path, info) {
  const $result = new Subject();
  const result = $sxhr.post(path, info);
  const isUn = result.subscribe(data => {
    if (
      data.result == 401 ||
      (data.result == 3 && data.desc == "SESSION无效!")
    ) {
      logout();
    } else {
      $result.next(data);
      $result.complete();
    }
    isUn.unsubscribe();
  });
  return $result;
}
export default {
  memberFormGet: info => {
    return httpPost("member/form/GetForNewForm", info);
  },
  contactGet: info => {
    return httpPost("api/member/contacts/info/get", info);
  },
  logout(info) {
    return httpPost("member/member/associate/Logout", info);
  },
  menuQuery(info) {
    return httpPost("api/member/personalcenter/menu/query", info);
  },
  webinarList(info) {
    return httpPost("webinar/open/getAttendList", info);
  },
  seminarList(info) {
    return httpPost("api/seminar/contacts/query", info);
  },
  downFileList(info) {
    return httpPost("api/file/download/record/query", info);
  },
  downloadWithEmail(info) {
    return httpPost("file/downloadWithEmail", info);
  },
  updateIdentityInfo(info) {
    return httpPost("member/UpdateIdentityInfo", info);
  },
  changePwd(info) {
    return httpPost("member/changePwd", info);
  },
  unbind(info) {
    return httpPost("member/unbind", info);
  },
  bind(info) {
    return httpPost("member/bind", info);
  },
  themeStyle(info) {
    return httpPost("api/theme/get", info);
  }
};
